import React from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import DataClientTable from "../../components/Data-client-table/data-client-table";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import './client.css';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { cardIconSx, clientListThemeVars } from "../../theme/globalStyle/globalStyle";
require('firebase/auth')

function ClientList(){
    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)
    const canCreateClient = user?.permissoes?.cliente?.cadastrar || user?.permissoes?.client?.isCreate;

    return(
        <>
            { 
                userLogado > 0 ? 
                    <NewMiniDrawer divOpen={
                        <Box className="client-list-page" sx={pageWrapperSx} style={clientListThemeVars}>
                            <Card sx={heroCardSx}>
                                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                    <Box className="client-list-hero">
                                        <Stack spacing={1} className="client-list-hero-copy">
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Box sx={cardIconSx}>
                                                    <PeopleAltOutlinedIcon sx={{ color: "#ffffff" }} />
                                                </Box>
                                                <Typography sx={heroTitleSx}>Clientes</Typography>
                                            </Box>
                                            <Typography sx={heroSubtitleSx}>
                                                Consulte, filtre e mantenha a base de clientes usada nas operacoes comerciais e de transporte.
                                            </Typography>
                                        </Stack>

                                        {
                                            canCreateClient ? (
                                                <Button
                                                    component={Link}
                                                    to="/client"
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    sx={primaryActionSx}
                                                >
                                                    Novo cliente
                                                </Button>
                                            )
                                            : (
                                            ""
                                            )
                                        }
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={contentCardSx}>
                                <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                                    <Box className="client-list-table-heading">
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={cardIconSx}>
                                                <TableRowsOutlinedIcon sx={{ color: "#ffffff" }} />
                                            </Box>
                                            <Box>
                                                <Typography sx={sectionTitleSx}>Lista de clientes</Typography>
                                                <Typography sx={sectionSubtitleSx}>Use os filtros das colunas para localizar registros especificos.</Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className="client-list-table-shell">
                                        <DataClientTable />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                }/>
                : 
                <Navigate to='/login' />
            }
        </>
    );
}

export default ClientList;

const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-soft)",
};

const contentCardSx = {
    borderRadius: "var(--client-radius-lg)",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-table)",
    background: "var(--client-surface-soft)",
};

const heroTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const sectionTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--client-primary-hover)",
    },
};
